import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

export const KnowledgeCenter = () => {
  return (
    <section id="knowledge" data-testid="knowledge-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <span className={EYEBROW}>Knowledge Center</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-[1.05] font-bold">
            Artikel & <span className="italic text-gold-dark">Panduan Hukum</span>
          </h2>
          <p className="mt-5 text-graytone-dark text-lg">
            Pusat pengetahuan hukum kami sedang disiapkan — pratinjau kategori yang akan hadir.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid md:grid-cols-3 gap-6"
        >
          {ARTICLES.map((a, i) => (
            <motion.article
              key={a.title}
              variants={fadeUp}
              data-testid={`article-${i}`}
              className="group relative flex flex-col rounded-3xl border border-graytone-medium/60 bg-graytone-light p-8 hover:shadow-medium hover:-translate-y-2 transition-all duration-400 overflow-hidden"
            >
              <span className="absolute top-6 right-6 rounded-full bg-navy/5 text-navy/50 text-[11px] font-semibold uppercase tracking-[0.15em] px-3 py-1.5">
                Segera Hadir
              </span>
              <span className="text-xs uppercase tracking-[0.2em] text-gold-dark font-bold">{a.category}</span>
              <h3 className="mt-4 font-serif text-2xl font-semibold text-navy leading-snug pr-4">{a.title}</h3>
              <p className="mt-3 text-sm text-graytone-dark leading-relaxed flex-1">{a.desc}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-navy/40">
                Baca selengkapnya
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </motion.article>
          ))}
        </motion.div>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-10 text-sm text-graytone-dark"
        >
          Artikel lengkap dan fitur pencarian akan tersedia setelah Knowledge Center diluncurkan.
        </motion.p>
      </div>
    </section>
  );
};
